var image_upload_default = {
  "container": "SL6Xq",
  "disabled": "t-BYs",
  "imageInput": "kklLx",
  "overlay": "hSsyJ",
  "text": "NbS4I",
  "shown": "_9YFWc",
  "hide": "tZdMX",
  "spinner": "kpIps",
  "spin": "_6n3UA"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
